import { LABEL_CLASS } from '@redirector/front/lib/formStyles';

interface FormFieldProps {
  label: string;
  htmlFor: string;
  required?: boolean;
  error?: string | null;
  children: React.ReactNode;
}

export default function FormField({
  label,
  htmlFor,
  required = false,
  error = null,
  children,
}: FormFieldProps) {
  return (
    <div>
      <label htmlFor={htmlFor} className={LABEL_CLASS}>
        {label}
        {required && <span className="text-red-400 ml-0.5">*</span>}
      </label>
      {children}
      {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
    </div>
  );
}
